import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from '@repo/ui-primitives/skeleton';
function PeopleCardSkeleton() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col w-full max-w-[17.625rem] bg-card rounded-lg p-1 text-sm text-muted-foreground",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "w-[60px] h-5"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "w-[70px] h-5"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-1 mt-1",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "w-[15px] h-5"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "w-[100px] h-5"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-2 mt-4",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "rounded-full w-9 h-9"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "rounded-full w-9 h-9"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "rounded-full w-9 h-9"
                    })
                ]
            })
        ]
    });
}
export { PeopleCardSkeleton };
